import { render, staticRenderFns } from "./ArtworkTool.vue?vue&type=template&id=2881a71c&scoped=true"
import script from "./ArtworkTool.vue?vue&type=script&lang=js"
export * from "./ArtworkTool.vue?vue&type=script&lang=js"
import style0 from "./ArtworkTool.vue?vue&type=style&index=0&id=2881a71c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2881a71c",
  null
  
)

export default component.exports